/* tslint:disable:object-literal-shorthand */
import {Injectable, Output, EventEmitter} from '@angular/core';
import {Observable, of} from 'rxjs';
import {take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ExgModalService {

  isOpen = false;
  componentName = '';

  onAction: EventEmitter<any> = new EventEmitter();
  onClose: EventEmitter<void> = new EventEmitter();

  // tslint:disable-next-line:no-output-native
  @Output()
  change: EventEmitter<boolean> = new EventEmitter();
  initialize: EventEmitter<string> = new EventEmitter();
  update: EventEmitter<any> = new EventEmitter();

  toggled: EventEmitter<any> = new EventEmitter<any>();

  // Snackbars AKA ToastMessages
  private lastToastId: string | null = null;

  public forceToggleEvent = false;

  // Widget Modal
  show(componentName: string, data: any, forceToggleEvent: boolean = false): Observable<any> {
    this.forceToggleEvent = forceToggleEvent;
    if (!this.isOpen) {

      this.componentName = componentName;
      this.initialize.emit(this.componentName);
      this.update.emit(data);

      this.isOpen = true;
      this.change.emit(this.isOpen);

      const obs = new Observable((observer) => {
        this.onAction.subscribe((args: any) => {
          observer.next(args);
          observer.complete();
          this.isOpen = false;
          this.change.emit(this.isOpen);
        });
        this.onClose.subscribe((args: any) => {
          observer.next(undefined);
          observer.complete();
          this.isOpen = false;
          this.change.emit(this.isOpen);
        });
      });

      return obs.pipe(take(1));
    }
    return of();
  }

  action(args: any): void {
    this.onAction.emit(args);
  }

  close(): void {
    this.onClose.emit();
  }

  // Simple Modal
  showSimple(title: string,
             message: string,
             btnOk: boolean,
             btnCancel: boolean,
             btnOkCaption: string,
             btnCancelCaption: string, forceToggleEvent: boolean = false): Observable<any> {
    const data = {
      title: title,
      message: message,
      btnOk: btnOk,
      btnCancel: btnCancel,
      btnOkCaption: btnOkCaption,
      btnCancelCaption: btnCancelCaption
    };

    return this.show('ExgModalSimpleComponent', data, forceToggleEvent);
  }

  // Commit Dialog
  showAlert(message: string, btnOk: boolean, btnCancel: boolean, btnOkCaption: string, btnCancelCaption: string): Observable<any> {
    const data = {message: message, btnOk: btnOk, btnCancel: btnCancel, btnOkCaption: btnOkCaption, btnCancelCaption: btnCancelCaption};

    return this.show('ExgModalSimpleComponent', data);
  }

  private lastToastRemove(newID: string): void {
    if (this.lastToastId) {
      const el = document.getElementById(`exc-tst-${this.lastToastId}`);
      if (el) {
        el.remove();
      }
    }
    this.lastToastId = newID;
  }

  showToast(tstMessage: string, tstClass: string, tstIcon?: string | undefined): void {
    let showtime = 3000;
    if(tstMessage !== undefined && tstMessage !== null)
    {
      showtime = showtime + (Math.ceil(tstMessage.length / 80) * 1000);
    }
    showtime = Math.min(showtime, 10000);
    const id = Math.random().toString(36).substring(2);
    this.lastToastRemove(id);
    const html = `<div class="${tstClass} animate" id="exc-tst-${id}"><i class="${tstIcon}"></i>${tstMessage}</div>`;
    document.body.insertAdjacentHTML('afterbegin', html);
    setTimeout(() => {
      const r = document.getElementById(`exc-tst-${id}`);
      if (r) {
        r.remove();
      }
    }, showtime);
  }

  showToastCommit(tstMessage: string,
                  tstClass: string,
                  tstCommit: string,
                  tstIcon?: string | undefined,
                  commitCallbackFn?: (() => void) | undefined): void {
    const id = Math.random().toString(36).substring(2);
    this.lastToastRemove(id);
    const html = `<div class="${tstClass}" id="exc-tst-${id}"><i class="${tstIcon}"></i>${tstMessage}<button id="exc-tst-btn-${id}">${tstCommit}</button></div>`;
    document.body.insertAdjacentHTML('afterbegin', html);
    const el: HTMLElement | null = document.getElementById(`exc-tst-${id}`);
    const elBtn: HTMLElement | null = document.getElementById(`exc-tst-btn-${id}`);
    if (el === null || elBtn === null) {
      return;
    }
    const evLstnr = () => {
      if (commitCallbackFn) {
        commitCallbackFn();
      }
      elBtn.removeEventListener('click', evLstnr);
      el.remove();
    };
    elBtn.addEventListener('click', evLstnr);
  }
}
